import { defineComponent as _defineComponent } from 'vue'
import { ArrowIcons } from '@/components/common/RotatingArrow/types';
import DropdownRotatingArrow from '@/components/common/RotatingArrow/DropdownRotatingArrow.vue';
import { computed } from 'vue';
import { useInject } from '@/components/SideBar/composables';
import { FlowRunAssetsKey, ProgressBarMenuKey } from './types';
import ProgressBar from '@/components/common/WorkflowStatus/ProgressBar.vue';
import { showFlowRunPercentage } from '@/views/FlowRun/flow-run-service';

export default /*#__PURE__*/_defineComponent({
  __name: 'TileProgressBarMenu',
  setup(__props) {

const { progressBarMenu, setProgressBarMenu } = useInject(ProgressBarMenuKey);
const isMenuOpen = computed<boolean>({
	get() {
		return progressBarMenu.value;
	},
	set(value) {
		setProgressBarMenu(value);
	},
});
const { restart, isFinalized, nodeRuns, percentCompleted, status, text } = useInject(FlowRunAssetsKey);

const dummyMethod = (n: string) => console.log(`${n} was clicked`);
const showPercentage = computed(() => showFlowRunPercentage(status.value));

return { __sfc: true,progressBarMenu, setProgressBarMenu, isMenuOpen, restart, isFinalized, nodeRuns, percentCompleted, status, text, dummyMethod, showPercentage, ArrowIcons, DropdownRotatingArrow, ProgressBar }
}

})